import React from 'react';
import './index.css';
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import {Main} from "./Main";
import {initRum} from "./app/rum";

initRum();

const root = createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Main/>
    </BrowserRouter>
);